<template>
  <div
    v-if="item.isKit"
    class="d-flex align-items-center"
  >
    <b-badge
      variant="primary"
      class="mr-50"
    >
      {{ $t('Kit') }}
    </b-badge>
    <span class="font-weight-bold">{{ item.name }}</span>
  </div>
  <div
    v-else-if="item.isKitItem"
    class="d-flex align-items-center kit-item-name"
  >
    <b-icon
      icon="arrow-return-right"
      class="mr-50"
    />
    <span>{{ item.name }}</span>
  </div>
  <span v-else>{{ item.name }}</span>
</template>

<script>
import { BBadge, BIcon } from 'bootstrap-vue'

export default {
  components: { BBadge, BIcon },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.kit-item-name {
  padding-left: 20px;
}
</style>
